/* eslint-disable */
// import Libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

// import custom Components
import ContentWithNavigationSidebar from 'legacy/layouts/ContentWithNavigationSidebar';
import ContentHeader from 'legacy/containers/ContentHeader';
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent';
import EcgLoader from 'legacy/containers/EcgLoader';

import PageTab from '../../../legacy/components/PageTab';
import PageTabs from '../../../legacy/components/PageTabs';

import { UserProfileContext } from 'auth/contexts/UserProfileContext';
import { DATASOURCES, getDataSource } from 'state/services/utils';
import { checkIdtfFeatureEnabled } from 'configs';

import KardiaRxPatientResult from '../../containers/KardiaRxPatientResult';
import {
  getKardiaRxPatientsData,
  handleOnRefreshClick,
  getKardiaRxPatientsAutoComplete,
} from '../../state/kardiaRxIdtf/KardiaRxIDTFPatientsActions';
import KardiaRxSearchBar from '../../containers/KardiaRxSearch/KardiaRxSearchBar';

// import css
import styles from './KardiaRx.css';

/**
 * Page - KardiaRx - Patient Connection list
 *
 */
class KardiaRx extends Component {
  UNSAFE_componentWillMount() {
    this.props.getKardiaRxPatientsData();
    this.props.getKardiaRxPatientsAutoComplete();
  }

  render() {
    const {
      me,
      intl,
      refreshData,
      RX_PATIENTS_CONNECTION_LIST_STATE,
    } = this.props;

    if (!checkIdtfFeatureEnabled(me)) {
      return (
        <ContentWithNavigationSidebar>
          <div data-page="kardiaRx" className={styles.KardiaRxPage}>
            <AccessDeniedContent
              // title={intl.formatMessage({ id: 'search.PageTitle' })}
              title="AliveCor Labs"
            />
          </div>
        </ContentWithNavigationSidebar>
      );
    }

    return (
      <ContentWithNavigationSidebar>
        <div data-page="kardiaRx" className={styles.KardiaRxPage}>
          <ContentHeader
            isLoading={me.isFetching}
            showLastRefresh={!me.isFetching}
            lastUpdated={
              RX_PATIENTS_CONNECTION_LIST_STATE.patients.dataLastUpdated
            }
            handleOnRefreshClick={refreshData}
            text="AliveCor Labs"
            enrollPatient = {true}
            me={me}
          />
          <React.Fragment>
            <KardiaRxSearchBar />
            {RX_PATIENTS_CONNECTION_LIST_STATE.patients.isFetching ? (
              <EcgLoader />
            ) : (
              <React.Fragment>
                <div className={styles.pageTab}>
                  <PageTabs>
                    <PageTab
                      dataAction="KardiaRx Patients"
                      isActive={true}
                      // Disabling the count as of now. Can be enabled later
                      // getLabel={
                      //   RX_PATIENTS_CONNECTION_LIST_STATE.patients &&
                      //   RX_PATIENTS_CONNECTION_LIST_STATE.patients.data &&
                      //   RX_PATIENTS_CONNECTION_LIST_STATE.patients.data
                      //     .length &&
                      //   RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0]
                      //     .objectCount &&
                      //   RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0]
                      //     .objectCount !== undefined
                      //     ? () => (
                      //         <React.Fragment>
                      //           KardiaRx Patients
                      //           <div className={styles.badgeCount}>
                      //             {
                      //               RX_PATIENTS_CONNECTION_LIST_STATE.patients
                      //                 .data[0].objectCount
                      //             }
                      //           </div>
                      //         </React.Fragment>
                      //       )
                      //     : () => 'KardiaRx Patients'
                      // }
                      getLabel={() => 'KardiaRx Patients'}
                    />
                  </PageTabs>
                </div>
                <div className={styles.KardiaRxContainer}>
                  <KardiaRxPatientResult {...this.props} />
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        </div>
      </ContentWithNavigationSidebar>
    );
  }
}

KardiaRx.contextType = UserProfileContext;

const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const RX_PATIENTS_CONNECTION_LIST_STATE = state.kardiaRx.kardiaRxIDTFPatients;
  // const { form, search } = state;
  return {
    me,
    RX_PATIENTS_CONNECTION_LIST_STATE,
  };
};

const mapActionCreators = {
  getKardiaRxPatientsData,
  refreshData: handleOnRefreshClick,
  getKardiaRxPatientsAutoComplete,
};

export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(KardiaRx));



// WEBPACK FOOTER //
// ./src/views/pages/KardiaRx/KardiaRx.jsx